import fetch from '../utils/fetch'

export function addZitiLocation(params) {
  return fetch({
    url: '/pickuplocation',
    method: 'post',
    params
  })
}

// 獲取自取點列表
export function getZitiLocationList(params) {
  return fetch({
    url: '/pickuplocation/list',
    method: 'get',
    params
  })
}

// 獲取自取點詳情
export function getZitiLocation(id) {
  return fetch({
    url: `/pickuplocation/${id}`,
    method: 'get'
  })
}

// 更新自取點
export function updateZitiLocation(id, params) {
  return fetch({
    url: `/pickuplocation/${id}`,
    method: 'put',
    params
  })
}

// 刪除自取點
export function deleteZitiLocation(id) {
  return fetch({
    url: `/pickuplocation/${id}`,
    method: 'delete'
  })
}

// 自取點關聯門店
export function bindZitiLocation(params) {
  return fetch({
    url: `pickuplocation/reldistributor`,
    method: 'post',
    params
  })
}

// 自取點取消關聯門店
export function unbindZitiLocation(params) {
  return fetch({
    url: `pickuplocation/reldistributor/cancel`,
    method: 'post',
    params
  })
}
